import { render } from "./CheckAccountsCreated.vue?vue&type=template&id=b264186e&scoped=true"
import script from "./CheckAccountsCreated.vue?vue&type=script&lang=js"
export * from "./CheckAccountsCreated.vue?vue&type=script&lang=js"

import "./CheckAccountsCreated.vue?vue&type=style&index=0&id=b264186e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b264186e"]])

export default __exports__